export const FEDERAL = 'federal';
export const STATE = 'state';
export const LOCAL = 'local';

export const SCORE_DESCRIPTIONS = {
  1: 'A score of 1.0 indicates a race where your donation has minimal impact on the outcome.',
  2: 'A score of 2.0 suggests a race where your donation has a small but noticeable impact.',
  3: 'A score of 3.0 represents a race where your donation can make a moderate difference.',
  4: 'A score of 4.0 indicates a race where your donation has significant potential impact.',
  5: 'A score of 5.0 shows a race where your donation can have substantial influence.',
  6: 'A score of 6.0 represents a race where your donation has high potential impact.',
  7: 'A score of 7.0 indicates a race where your donation can be very influential.',
  8: 'A score of 8.0 shows a race where your donation has extremely high impact potential.',
  9: 'A score of 9.0 represents a race where your donation can be game-changing.',
  10: 'A score of 10.0 indicates a race where your donation has maximum possible impact.',
};
